import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/movies.png';

const EffectsIndustry = () => {
  return (
    <IndustryPageTemplate
      title="Effects"
      subtitle="Cinematic VFX at Your Fingertips"
      desc="Add cinematic effects and make your content stand out instantly. From explosive action to subtle environmental tweaks, our effects library has you covered."
      image={image}
      themeColor="#1976d2"
      bgGradient="linear-gradient(135deg, rgba(25,118,210,0.15), rgba(255,255,255,0))"
      features={[
  {
    "title": "Visual Effects",
    "desc": "Integrate realistic fire, smoke, rain, and environmental VFX seamlessly."
  },
  {
    "title": "Transitions",
    "desc": "Use dynamic camera movements and glitch transitions between clips."
  },
  {
    "title": "Motion Graphics",
    "desc": "Add professional lower thirds, title cards, and animated elements."
  },
  {
    "title": "3D & Animation",
    "desc": "Import 3D models and animate them directly within your scene."
  }
]}
    />
  );
};

export default EffectsIndustry;
